// const baseUrl = 'http://localhost:5001'

// const baseUrl = 'https://noix-server.onrender.com'

// const baseUrl = 'https://server.noix.space'

const baseUrl = ''

export default baseUrl